import React from 'react'

const Features = () => {
  return (
    <>
   <div className='captions'>
    <div className='captions-heading'>
      <h1>Become a Plus User</h1>
       <h2>And unlock powerful features:</h2>
   </div>
<div className='features-style'>
    <ul>
        <li><img src='https://api.iconify.design/mdi:checkbox-marked-circle.svg?color=%23bbddce' />
         Browse W3Schools<strong>without ads</strong></li>
         <li><img src='https://api.iconify.design/mdi:checkbox-marked-circle.svg?color=%23bbddce' />
         Build and host Websites</li>
         <li><img src='https://api.iconify.design/mdi:checkbox-marked-circle.svg?color=%23bbddce' />
         Unlimited challenges</li>
         <li><img src='https://api.iconify.design/mdi:checkbox-marked-circle.svg?color=%23bbddce' />
         Unlimited practice tests</li>
         <li><img src='https://api.iconify.design/mdi:checkbox-marked-circle.svg?color=%23bbddce' />
         Get extra credits</li>
         <li><img src='https://api.iconify.design/mdi:checkbox-marked-circle.svg?color=%23bbddce' />
         Priority support</li>
    </ul>
</div>
     <div className='learning-btn'>
    <div className='spacing-button'>Learn More</div>
</div></div>
<hr></hr>
  
   
    </>
  );
}

export default Features;                